import { DateHelpers } from './DateHelpers';

export namespace MapperHelper {
  export const REST_API_BASE_URL = '/vizportal/api/rest/v1/';

  export function toDate(value: string): Date | undefined {
    return DateHelpers.fromISOString(value);
  }
}
